module.exports = __webpack_public_path__ + "1fc49e02de69d9015780a950161edc4f.png";